import angular from 'angular';
import { exportTranslationsToCsv } from './translateExportSvc';

angular
  .module('cxTranslations')
  .controller('TranslateListsCtrl', [
    '$filter',
    'translateSvc',
    'localStorageService',
    TranslateListsCtrl,
  ]);

function formatSource(source) {
  if (!source) return '';
  const parts = source
    .split(',')
    .map(x => x.trim())
    .unique();
  return parts.join(', ');
}

function TranslateListsCtrl($filter, translateSvc, localStorageService) {
  var vm = this;
  //Filters
  vm.fNotTranslated = true;
  vm.fInherited = false;
  vm.fListName = null;
  //Data
  vm.loading = false;
  vm.languages = [];
  vm.allLanguages = [];
  vm.translations = [];
  vm.allTranslations = [];
  vm.pagedTranslations = [];
  vm.pageSize = 100;
  vm.pageSizeOptions = [50, 100, 200, 500];
  vm.currentPage = 1;
  vm.totalPages = 1;
  vm.listNames = [];
  vm.selectedLanguages = localStorageService.get('TranslationToolLanguages') || ['nl'];

  //Visibility Toggles
  vm.showModifiedDates = false;
  vm.showScanInfo = false;
  vm.showKey = false;

  //Language functions

  //Add a language column to the table
  vm.addLanguage = function(lang) {
    if (!lang) return;
    vm.selectedLanguages.push(lang);
    localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
    vm.filterLanguages();
    vm.getTranslations([lang]);
  };
  //Remove a language column
  vm.removeLanguage = function(lang) {
    if (!lang) return;
    var idx = vm.selectedLanguages.indexOf(lang);
    if (idx >= 0) {
      vm.selectedLanguages.splice(idx, 1);
      vm.filterLanguages();
      localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
      vm.filterTranslations();
    }
  };

  vm.filterLanguages = function() {
    vm.languages = vm.allLanguages.filter(function(lang) {
      return vm.selectedLanguages.indexOf(lang) < 0;
    });
  };

  //Translation functions
  vm.getTranslations = function(languages) {
    if (!languages || !languages.length) return;
    vm.loading = true;
    return translateSvc.getLists(vm.selectedLanguages).then(function(data) {
      if (vm.allTranslations.length) {
        //When adding language
        for (var i = 0; i < data.length; i++) {
          var group = data[i];
          var translation = vm.allTranslations.find(function(x) {
            return x.key === group.key;
          });
          if (!translation) {
            translation = {
              key: group.key,
              lastScanned: group.lastScanned,
              source: formatSource(group.source),
              defaultValue: group.defaultValue,
              list: group.list,
            };
            vm.allTranslations.push(translation);
          }
          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);

          if (
            !vm.listNames.find(function(x) {
              return x === group.list;
            })
          )
            vm.listNames.push(group.list);
        }
      } else {
        //Reloading all
        vm.allTranslations = data.map(function(group) {
          var translation = {
            key: group.key,
            lastScanned: group.lastScanned,
            source: formatSource(group.source),
            defaultValue: group.defaultValue,
            list: group.list,
          };

          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);

          if (
            !vm.listNames.find(function(x) {
              return x === group.list;
            })
          )
            vm.listNames.push(group.list);

          return translation;
        });
      }
      vm.listNames.sort();
      vm.filterTranslations();
      vm.loading = false;
    });
  };

  vm.reloadTranslations = function() {
    vm.allTranslations = [];
    vm.listNames = [];
    vm.getTranslations(vm.selectedLanguages);
  };

  vm.filterTranslations = function() {
    vm.translations = vm.allTranslations.filter(function(item) {
      if (vm.showNotScanned) {
        if (item.source || item.lastScanned) return false;
      }
      if (!!vm.fListName && item.list !== vm.fListName) return false;

      if (vm.fNotTranslated) {
        for (var i = 0; i < vm.selectedLanguages.length; i++) {
          var trans = item[vm.selectedLanguages[i]];
          if (!trans) return false;
          if (!(trans.value || (vm.fInherited && trans.inherited))) return true;
        }
        return false;
      }

      return true;
    });
    vm.translations = $filter('filter')(vm.translations, vm.search);

    vm.translations = $filter('orderBy')(vm.translations, vm.predicate, vm.reverse);

    vm.totalPages = Math.max(1, Math.ceil(vm.translations.length / vm.pageSize));
    if (vm.currentPage > vm.totalPages) vm.currentPage = vm.totalPages;
    if (vm.currentPage < 1) vm.currentPage = 1;
    vm.updatePage();
  };

  vm.updatePage = function() {
    var start = (vm.currentPage - 1) * vm.pageSize;
    vm.pagedTranslations = vm.translations.slice(start, start + vm.pageSize);
  };

  vm.setPage = function(page) {
    if (page < 1 || page > vm.totalPages) return;
    vm.currentPage = page;
    vm.updatePage();
  };

  vm.nextPage = function() {
    vm.setPage(vm.currentPage + 1);
  };

  vm.prevPage = function() {
    vm.setPage(vm.currentPage - 1);
  };

  vm.firstPage = function() {
    vm.setPage(1);
  };

  vm.lastPage = function() {
    vm.setPage(vm.totalPages);
  };

  vm.changePageSize = function() {
    vm.currentPage = 1;
    vm.filterTranslations();
  };

  vm.onFilterChange = function() {
    vm.currentPage = 1;
    vm.filterTranslations();
  };

  vm.removeTranslation = function(item) {
    translateSvc.removeList(item.key, 1).then(function() {
      var idx = vm.translations.findIndex(function(x) {
        return x.key === item.key;
      });
      if (idx >= 0) vm.translations.splice(idx, 1);

      idx = vm.allTranslations.findIndex(function(x) {
        return x.key === item.key;
      });
      if (idx >= 0) vm.allTranslations.splice(idx, 1);
      vm.filterTranslations();
    });
  };

  vm.save = function(item, lang, value) {
    translateSvc.saveList(lang, item.key, value, 1);
  };

  vm.coverage = function(item) {
    var covered = 0;
    for (var i = 0; i < vm.selectedLanguages.length; i++) {
      var t = item[vm.selectedLanguages[i]];
      if (t && t.value) covered++;
    }
    return covered;
  };

  vm.coverageClass = function(item) {
    var c = vm.coverage(item);
    var total = vm.selectedLanguages.length;
    if (c === 0) return 'label-danger';
    if (c < total) return 'label-warning';
    return 'label-success';
  };

  vm.exportToCsv = function() {
    exportTranslationsToCsv({
      translations: vm.translations,
      selectedLanguages: vm.selectedLanguages,
      includeList: true,
      fileName: 'translations-lists-' + new Date().toISOString().slice(0, 10) + '.csv',
    });
  };

  //Sorting
  vm.predicate = 'key';
  vm.reverse = false;
  vm.sort = function(predicate) {
    vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
    vm.predicate = predicate;

    vm.translations = $filter('orderBy')(vm.translations, vm.predicate, vm.reverse);
    vm.updatePage();
  };
  //Load languages
  vm.allLanguages = translateSvc.languages;
  vm.filterLanguages();
  //Trigger initial load
  vm.reloadTranslations();
}
